import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as RegionsActions } from 'store/ducks/regions';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Regions/components';

class Edit extends Component {
  state = {
    data: {
      name: '',
      places: [],
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Regiões', to: '/regions' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getRegionRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { region } = this.props;

    if (oldProps.region.loading && !region.loading) {
      this.setState({
        data: {
          name: region.data.attributes.name,
          places: region.data.attributes.places.map(place => ({
            value: place.id,
            label: place.name
          })),
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/regions/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.updateRegionRequest(this.handleGetId(), {
      region: {
        name: form.name,
        place_ids: form.places.map(place => place.value)
      }
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={update.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  region: state.regions.detail,
  update: state.regions.update,
});

const mapActions = dispatch => bindActionCreators(RegionsActions, dispatch);

export default connect(mapState, mapActions)(Edit);
